import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { Author } from "./author";
import { ChatMedia } from "./chat-media";
import { Member } from "./member";
import { TrackLink } from "./track-link";

export class Chat {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.saveBookmarkId = asString(json.saveBookmarkId);
    this.loveBookmarkId = asString(json.loveBookmarkId);
    this.isLoved = asBoolean(json.isLoved);
    this.isBookmarked = asBoolean(json.isBookmarked);
    this.archive = asBoolean(json.archive);
    this.systemRemove = asBoolean(json.systemRemove);
    this.commentEdit = asBoolean(json.commentEdit);
    this.expire = asBoolean(json.expire);
    this.forwarded = asBoolean(json.forwarded);
    this.pin = asBoolean(json.pin);
    this.chatId = asString(json.chatId);
    this.sectionName = asString(json.sectionName);
    this.comment = asString(json.comment);
    this.trackId = asString(json.trackId);
    this.node = asString(json.node);
    this.parentId = asString(json.parentId);
    this.commentType = asString(json.commentType);
    this.section = asString(json.section);
    this.sectionId = asString(json.sectionId);
    this.orgId = asString(json.orgId);
    this.memberId = asString(json.memberId);
    this.totalComment = asNumber(json.totalComment);
    this.totalLoves = asNumber(json.totalLoves);
    this.totalBookmarks = asNumber(json.totalBookmarks);
    this.userId = asString(json.userId);
    this.appId = asString(json.appId);
    this.appName = asString(json.appName);
    this.drive = asBoolean(json.drive) ?? false;
    this.hasAudio = asBoolean(json.hasAudio) ?? false;
    this.audio = ChatMedia.fromJson(json.audio);
    this.audioStartTime = asNumber(json.audioStartTime);
    this.audioEndTime = asNumber(json.audioEndTime);
    this.severity = asString(json.severity);
    this.appData = isObject(json.appData) ? { ...json.appData } : json.appData;
    this.author = Author.fromJson(json.author);
    this.country = asString(json.country);
    this.expireDate = asDate(json.expireDate);
    this.createdAt = asDate(json.createdAt);
    this.updatedAt = asDate(json.updatedAt);
    this.member = Member.fromJson(json.member);
    this.pinBy = Author.fromJson(json.pinBy);
    this.media = parseList(json.media, ChatMedia.fromJson);
    this.reference = isObject(json.reference) ? { ...json.reference } : json.reference;
    this.link = isObject(json.link) ? { ...json.link } : json.link;
    this.trackLink = parseList(json.trackLink, TrackLink.fromJson);
    this.host = isObject(json.host) ? { ...json.host } : json.host;
    this.score = isObject(json.score) ? { ...json.score } : json.score;
    this.mention = parseList(json.mention, Member.fromJson);
    this.handles = Array.isArray(json.handles) ? json.handles : [];
  }

  static fromJson(json: any) {
    return isObject(json) ? new Chat(json) : json;
  }
}
